let i18n = null
export default function getI18n() {
  return i18n
}
export function setI18n(instance) {
  i18n = instance
}
